export default [
  {
    "id": "mat-enem-0430",
    "numero": 1930,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Cinco empresas de gêneros alimentícios encon-\ntram-se à venda. Um empresário, almejando \nampliar os seus investimentos, deseja comprar \numa dessas empresas. Para escolher qual de-\nlas irá comprar, analisa o lucro (em milhões de \nreais) de cada uma delas, em função de seus \ntempos (em anos) de existência, decidindo \ncomprar a empresa que apresente o maior lucro \nmédio anual. \n \nO quadro apresenta o lucro (em milhões de \nreais) acumulado ao longo do tempo (em anos) \nde existência de cada empresa. \n \n \nO empresário decidiu comprar a empresa: \n \nA) F. \nB) G. \nC) H. \nD) M. \nE) P.",
    "alternativas": {
      "C": "H.",
      "D": "M.",
      "E": "P.",
      "B": "G."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 430,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0431",
    "numero": 1931,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Deseja-se postar cartas não comerciais, sendo \nduas de 100 g, três de 200 g e uma de 350 g. O \ngráfico mostra o custo para enviar uma carta \nnão comercial pelos Correios: \n \n \n \nO valor total gasto, em reais, para postar essas \ncartas é de: \n \nA) 8,35. \nB) 12,50. \nC) 14,40. \nD) 15,35. \nE) 18,05.",
    "alternativas": {
      "A": "8,35.",
      "C": "14,40.",
      "D": "15,35.",
      "E": "18,05."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 431,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0432",
    "numero": 1932,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Foi realizado um levantamento nos 200 hotéis \nde uma cidade, no qual foram anotados os valo-\nres, em reais, das diárias para um quarto pa-\ndrão de casal e a quantidade de hotéis para \ncada valor da diária. Os valores das diárias fo-\nram: A = R$200,00; B = R$300,00; C = R$400,00 \ne D = R$600,00. No gráfico, as áreas represen-\ntam as quantidades de hotéis pesquisados, em \nporcentagem, para cada valor da diária. \nO valor mediano da diária, em reais, para o \nquarto padrão de casal nessa cidade, é: \n \nA) 300,00. \nB) 345,00. \nC) 350,00. \nD) 375,00. \nE) 400,00.",
    "alternativas": {
      "B": "345,00.",
      "C": "350,00.",
      "E": "400,00.",
      "A": "300,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 432,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0433",
    "numero": 1933,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Para aumentar as vendas no início do ano, uma \nloja de departamentos remarcou os preços de \nseus produtos 20% abaixo do preço original. \nQuando chegam ao caixa, os clientes que pos-\nsuem o cartão fidelidade da loja têm direito a um \ndesconto adicional de 10% sobre o valor total de \nsuas compras. \n \nUm cliente deseja comprar um produto que cus-\ntava R$ 50,00 antes da remarcação de preços. \nEle não possui o cartão fidelidade da loja. Caso \nesse cliente possuísse o cartão fidelidade da \nloja, a economia adicional que obteria ao efetuar \na compra, em reais, seria de \n \nA) 15,00. \nB) 14,00. \nC) 10,00. \nD) 5,00. \nE) 4,00.",
    "alternativas": {
      "B": "14,00.",
      "C": "10,00.",
      "E": "4,00.",
      "A": "15,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 433,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0435",
    "numero": 1935,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Um artesão de joias tem à sua disposição pe-\ndras brasileiras de três cores: vermelhas. azuis \ne verdes. Ele pretende produzir joias constituí-\ndas por uma liga metálica, a partir de um molde \nno formato de um losango não quadrado com \npedras nos seus vértices, de modo que dois \nvértices consecutivos tenham sempre pedras de \ncores diferentes.  \n \nA figura ilustra uma joia, produzida por esse \nartesão, cujos vértices A, B, C e D correspon-\ndem às posições ocupadas pelas pedras. \n \n \n \nCom base nas informações fornecidas, quantas \njoias diferentes, nesse formato, o artesão pode-\nrá obter? \n \nA) 6 \nB) 12 \nC) 18 \nD) 24 \nE) 36",
    "alternativas": {
      "D": "24",
      "E": "36",
      "B": "12",
      "C": "18"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 435,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0436",
    "numero": 1936,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Em setembro de 1987, Goiânia foi palco do \nmaior acidente radioativo ocorrido no Brasil, \nquando uma amostra de césio-137, removida de \num aparelho de radioterapia abandonado, foi \nmanipulada inadvertidamente por parte da po-\npulação. A meia-vida de um material radioativo \né o tempo necessário para que a massa desse \nmaterial se reduza a metade. A meia-vida do \ncésio-137 é 30 anos e a quantidade restante de \nmassa de um material radioativo, após t anos, é \ncalculada pela expressão o M(t) = A ∙ (2,7)kt, \nonde A é a massa inicial e k uma constante \nnegativa. \n \nConsidere 0,3 como aproximação para log10 2. \n \nQual o tempo necessário, em anos, para que \numa quantidade de massa do césio-137 se re-\nduza a 10% da quantidade inicial? \n \nA) 27 \nB) 36 \nC) 50 \nD) 54 \nE) 100",
    "alternativas": {
      "A": "27",
      "C": "50",
      "D": "54",
      "E": "100"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 436,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0437",
    "numero": 1937,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A cerâmica constitui-se em um artefato bastante \npresente na história da humanidade. Uma de \nsuas várias propriedades é a retração (contra-\nção), que consiste na evaporação da água exis-\ntente em um conjunto ou bloco cerâmico quan-\ndo submetido a uma determinada temperatura \nelevada. Essa elevação de temperatura, que \nocorre durante o processo de cozimento, causa \numa redução de até 20% nas dimensões linea-\nres de uma peça. \n \nSuponha que uma peça, quando moldada em \nargila, possuía uma base retangular cujos lados \nmediam 30 cm e 15 cm. Após o cozimento, es-\nses lados foram reduzidos em 20%. Em relação \nà área original, a área da base dessa peça, \napós o cozimento, ficou reduzida em: \n \nA) 4%  \nB) 20%  \nC) 36%. \nD) 64% \nE) 96%",
    "alternativas": {
      "C": "36%.",
      "E": "96%",
      "A": "4%",
      "B": "20%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 437,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0438",
    "numero": 1938,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma fábrica de parafusos possui duas máqui-\nnas, I e II para a produção de certo tipo de para-\nfuso. Em setembro, a máquina I produziu 54/10 \ndo total de parafusos produzidos pela fábrica. \nDos parafusos produzidos por essa máquina, \n25/1000 eram defeituosos. Por sua vez, 38/1000 \ndos parafusos produzidos no mesmo mês pela \nmáquina II eram defeituosos.  \n \nO desempenho conjunto das duas máquinas é \nclassificado conforme o quadro, em que P indica \na probabilidade de um parafuso escolhido ao \nacaso ser defeituoso. \n \n \nO desempenho conjunto dessas máquinas, em \nsetembro, pode ser classificado como: \n \nA) excelente. \nB) bom. \nC) regular. \nD) ruim. \nE) péssimo.",
    "alternativas": {
      "A": "excelente.",
      "B": "bom.",
      "C": "regular.",
      "E": "péssimo."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 438,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0439",
    "numero": 1939,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Considere o seguinte jogo de apostas:  \n \nNuma cartela com 60 números disponíveis, um \napostador escolhe de 6 a 10 números. Dentre \nos números disponíveis, serão sorteados ape-\nnas 6. O apostador será premiado caso os 6 \nnúmeros sorteados estejam entre os números \nescolhidos por ele numa mesma cartela.  \n \nO quadro apresenta o preço de cada cartela, de \nacordo com a quantidade de números escolhi-\ndos. \n \n \n \nCinco apostadores, cada um com R$ 500,00 \npara apostar, fizeram as seguintes opções:  \n \nArthur: 250 cartelas com 6 números escolhidos;  \n \nBruno: 41 cartelas com 7 números escolhidos e \n4 cartelas com 6 números escolhidos;  \n \nCaio: 12 cartelas com 8 números escolhidos e \n10 cartelas com 6 números escolhidos;  \n \nDouglas: 4 cartelas com 9 números escolhidos;  \n \nEduardo: 2 cartelas com 10 números escolhi-\ndos. \nOs dois apostadores com maiores probabilida-\ndes de serem premiados são: \n \nA) Caio e Eduardo.  \nB) Arthur e Eduardo. \nC) Bruno e Caio.  \nD) Arthur e Bruno. \nE) Douglas e Eduardo.",
    "alternativas": {
      "C": "Bruno e Caio.",
      "D": "Arthur e Bruno.",
      "A": "Caio e Eduardo.",
      "B": "Arthur e Eduardo."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 439,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0440",
    "numero": 1940,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Nos Estados Unidos a unidade de medida de \nvolume mais utilizada em latas de refrigerante é \na onça fluida (fl oz), que equivale a aproxima-\ndamente 2,95 centilitros (cL).  \n \nSabe-se que o centilitro é a centésima parte do \nlitro e que a lata de refrigerante usualmente \ncomercializada no Brasil tem capacidade de 355 \nmL.  \n \nAssim, a medida do volume da lata de refrige-\nrante de 355 mL, em onça fluida (fl oz), é mais \npróxima de: \n \nA) 0,83. \nB) 1,20. \nC) 12,03. \nD) 104,73. \nE) 120,34.",
    "alternativas": {
      "D": "104,73.",
      "E": "120,34.",
      "B": "1,20.",
      "C": "12,03."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 440,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0441",
    "numero": 1941,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Na aferição de um novo semáforo, os tempos \nsão ajustados de modo que, em cada ciclo \ncompleto (verde-amarelo-vermelho), a luz ama-\nrela permaneça acesa por 5 segundos, e o tem-\npo em que a luz verde permaneça acesa seja \nigual a 2/3 do tempo em que a luz vermelha \nfique acesa. A luz verde fica acesa, em cada \nciclo, durante X segundos e cada ciclo dura Y \nsegundos. \n \nQual é a expressão que representa a relação \nentre X e Y? \n \nA) 5X – 3Y + 15 = 0 \nB) 5X – 2Y + 10 = 0 \nC) 3X – 3Y + 15 = 0  \nD) 3X – 2Y + 15 = 0  \nE) 3X – 2Y + 10 = 0",
    "alternativas": {
      "E": "3X – 2Y + 10 = 0",
      "A": "5X – 3Y + 15 = 0",
      "B": "5X – 2Y + 10 = 0",
      "D": "3X – 2Y + 15 = 0"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 441,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0442",
    "numero": 1942,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A temperatura T de um forno (em graus centí-\ngrados) é reduzida por um sistema a partir do \ninstante de seu desligamento (t = 0) e varia de \nacordo com a expressão T(t) = - \nt2\n4 + 400, com t \nem minutos. Por motivos de segurança, a trava \ndo forno só é liberada para abertura quando o \nforno atinge a temperatura de 39°C. \nQual o tempo mínimo de espera, em minutos, \napós se desligar o forno, para que a porta possa \nser aberta? \n \nA) 19,0  \nB) 19,8 \nC) 20,0 \nD) 38,0 \nE) 39,0",
    "alternativas": {
      "E": "39,0",
      "A": "19,0",
      "B": "19,8",
      "D": "38,0"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 442,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0443",
    "numero": 1943,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "O ciclo de atividade magnética do Sol tem um \nperíodo de 11 anos. O início do primeiro ciclo \nregistrado se deu no começo de 1755 e se es-\ntendeu até o final de 1765. Desde então, todos \nos ciclos de atividade magnética do Sol têm sido \nregistrados. \n \nNo ano de 2101, o Sol estará no ciclo de ativi-\ndade magnética de número: \n \nA) 32. \nB) 34. \nC) 33.  \nD) 35. \nE) 31.",
    "alternativas": {
      "C": "33.",
      "E": "31.",
      "A": "32.",
      "B": "34."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 443,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0444",
    "numero": 1944,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "A figura apresenta dois mapas, em que o estado \ndo Rio de Janeiro é visto em diferentes escalas. \n \n \n \nHá interesse em estimar o número de vezes que \nfoi ampliada a área correspondente a esse es-\ntado no mapa do Brasil. \n \nEsse número é: \n \nA) menor que 10. \nB) maior que 10 e menor que 20. \nC) maior que 20 e menor que 30. \nD) maior que 30 e menor que 40. \nE) maior que 40.",
    "alternativas": {
      "A": "menor que 10.",
      "B": "maior que 10 e menor que 20.",
      "C": "maior que 20 e menor que 30.",
      "D": "maior que 30 e menor que 40."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 444,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0445",
    "numero": 1945,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Nos últimos anos, a televisão tem passado por \numa verdadeira revolução, em termos de quali-\ndade de imagem, som e interatividade com o \ntelespectador. Essa transformação se deve à \nconversão do sinal analógico para o sinal digital. \nEntretanto, muitas cidades ainda não contam \ncom essa nova tecnologia. Buscando levar es-\nses benefícios a três cidades, uma emissora de \ntelevisão pretende construir uma nova torre de \ntransmissão, que envie sinal às antenas A, B e \nC, já existentes nessas cidades. As localizações \ndas antenas estão representadas no plano car-\ntesiano: \n \nA torre deve estar situada em um local equidis-\ntante das três antenas. \n \n \nO local adequado para a construção dessa torre \ncorresponde ao ponto de coordenadas: \n \nA) (65;35). \nB) (53;30). \nC) (45;35). \nD) (50;20). \nE) (50;30).",
    "alternativas": {
      "C": "(45;35).",
      "D": "(50;20).",
      "E": "(50;30).",
      "B": "(53;30)."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 445,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0446",
    "numero": 1946,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma cozinheira, especialista em fazer bolos, \nutiliza uma forma no formato representado na \nfigura: \n \n \nNela identifica-se a representação de duas figu-\nras geométricas tridimensionais. Essas figuras \nsão: \n \nA) um tronco de cone e um cilindro. \nB) um cone e um cilindro. \nC) um tronco de pirâmide e um cilindro. \nD) dois troncos de cone. \nE) dois cilindros.",
    "alternativas": {
      "E": "dois cilindros.",
      "A": "um tronco de cone e um cilindro.",
      "C": "um tronco de pirâmide e um cilindro.",
      "D": "dois troncos de cone."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 446,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0447",
    "numero": 1947,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Uma falsa relação \n \nO cruzamento da quantidade de horas estudadas com o desempenho no Programa Internacional de \nAvaliação de Estudantes (Pisa) mostra que mais tempo na escola não é garantia de nota acima da mé-\ndia. \nDos países com notas abaixo da média nesse \nexame, aquele que apresenta maior quantidade \nde horas de estudo é: \n \nA) Finlândia. \nB) Holanda. \nC) Israel. \nD) México. \nE) Rússia.",
    "alternativas": {
      "A": "Finlândia.",
      "B": "Holanda.",
      "C": "Israel.",
      "E": "Rússia."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 447,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0448",
    "numero": 1948,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Um restaurante utiliza, para servir bebidas, ban-\ndejas com bases quadradas. Todos os copos \ndesse restaurante têm o formato representado \nna figura: \n \n \n \nConsidere que AC\n̅̅̅̅ = \n7\n5\n BD\n̅̅̅̅ e que ι é a medida de \num dos lados da base da bandeja. \n \nQual deve ser o menor valor da razão \nl\nBD\n̅̅̅̅ para \nque uma bandeja tenha capacidade de portar \nexatamente quatro copos de uma só vez? \n \nA) 2 \nB) 14/5 \nC) 4 \nD) 24/5 \nE) 28/5",
    "alternativas": {
      "A": "2",
      "B": "14/5",
      "C": "4",
      "D": "24/5"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 448,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0449",
    "numero": 1949,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "O dono de um sítio pretende colocar uma haste \nde sustentação para melhor firmar dois postes \nde comprimentos iguais a 6 m e 4 m. A figura \nrepresenta a situação real na qual os postes são \ndescritos pelos segmentos AC e BD e a haste é \nrepresentada pelo segmento EF, todos perpen-\ndiculares ao solo, que é indicado pelo segmento \nde reta AB. Os segmentos AD e BC represen-\ntam cabos de aço que serão instalados. \n \n \nQual deve ser o valor do comprimento da haste \nEF? \n \nA) 1 m \nB) 2 m \nC) 2,4 m \nD) 3 m \nE) 2√6 m",
    "alternativas": {
      "C": "2,4 m",
      "D": "3 m",
      "A": "1 m",
      "B": "2 m"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.1",
    "numeroOriginal": 449,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0451",
    "numero": 1951,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Observe no gráfico alguns dados a respeito da \nprodução e do destino do lixo no Brasil no ano \nde 2010. \n \n \n \nA partir desses dados, supondo que todo o lixo \nbrasileiro, com exceção dos recicláveis, é desti-\nnado aos aterros ou aos lixões, quantos milhões \nde toneladas de lixo vão para os lixões? \n \n \nA) 76,8 \nB) 5,9 \nC) 42,7 \nD) 10,9 \nE) 7,6",
    "alternativas": {
      "E": "7,6",
      "A": "76,8",
      "C": "42,7",
      "D": "10,9"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 451,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0452",
    "numero": 1952,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Médicos alertam sobre a importância de educar \nas crianças para terem hábitos alimentares sau-\ndáveis. Por exemplo, analisando-se uma bola-\ncha com recheio de chocolate (25 g) e um pé de \nalface (25 g), observam-se as seguintes quanti-\ndades de nutrientes, respectivamente: \n \n• carboidratos: 15 g e 0,5 g; \n• proteínas: 1,9 g e 0,5 g. \n \nConsiderando as informações apresentadas, \nqual deve ser o número de pés de alface con-\nsumidos para se obter a mesma quantidade de \ncarboidratos de uma bolacha? \n \n \nA) 7 \nB) 30 \nC) 8 \nD) 14 \nE) 50",
    "alternativas": {
      "D": "14",
      "E": "50",
      "A": "7",
      "B": "30"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 452,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0453",
    "numero": 1953,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma escola da periferia de São Paulo está com \num projeto em parceria com as universidades \npúblicas. Nesse projeto piloto, cada turma en-\ncaminhará um aluno que esteja apresentando \ndificuldades de aprendizagem para um acom-\npanhamento especializado.  \nPara isso, em cada turma, foram aplicadas 7 \navaliações diagnósticas. Os resultados obtidos \nem determinada turma foram os seguintes: \n \n \n \nSabendo que o projeto visa atender o aluno que \napresentar a menor média nas avaliações, de-\nverá ser encaminhado o aluno: \n \nA) 2. \nB) 5. \nC) 3. \nD) 1. \nE) 4.",
    "alternativas": {
      "B": "5.",
      "C": "3.",
      "D": "1.",
      "A": "2."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 453,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0454",
    "numero": 1954,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O cometa Halley orbita o Sol numa trajetória \nelíptica periódica. Ele foi observado da Terra \nnos anos de 1836 e 1911. Sua última aparição \nfoi em 1986 e sua próxima aparição será em \n2061. \n \nQual é o ano da segunda aparição do cometa \nanterior ao ano de 2012? \n \n \nA) 1862 \nB) 1986 \nC) 1911 \nD) 1937 \nE) 1836",
    "alternativas": {
      "D": "1937",
      "A": "1862",
      "B": "1986",
      "C": "1911"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 454,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0455",
    "numero": 1955,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "ACESSO A INTERNET \nO gráfico mostra o número de pessoas que \nacessaram a internet, no Brasil, em qualquer \nambiente (domicílios, trabalho, escolas, lan \nhouses ou outros locais), nos segundos trimes-\ntres dos anos de 2009, 2010 e 2011. \n \nConsiderando que a taxa de crescimento do \nnúmero de acessos à internet no Brasil, do se-\ngundo trimestre de 2011 para o segundo trimes-\ntre de 2012, seja igual à taxa verificada no \nmesmo período de 2010 para 2011, qual é, em \nmilhões, a estimativa do número de pessoas \nque acessarão a internet no segundo trimestre \nde 2012? \n \n \nA) 83,3 \nB) 93,4 \nC) 86,7 \nD) 99,8 \nE) 82,1",
    "alternativas": {
      "E": "82,1",
      "B": "93,4",
      "C": "86,7",
      "D": "99,8"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 455,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0456",
    "numero": 1956,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Um fabricante de bebidas, numa jogada de \nmarketing, quer lançar no mercado novas emba-\nlagens de latas de alumínio para os seus refri-\ngerantes. As atuais latas de 350 mL devem ser \nsubstituídas por uma nova embalagem com \nmetade desse volume, conforme mostra a figu-\nra: \n \n \nDe acordo com os dados anteriores, qual a rela-\nção entre o raio r’ da embalagem de 175 mL e o \nraio r da embalagem de 350 mL? \n \n \nA) r’ = r \nB) r’ = r/2 \nC) r’ = 2r \nD) r’ = √r \nE) r’ = √2\n3",
    "alternativas": {
      "E": "r’ = √2 3",
      "A": "r’ = r",
      "C": "r’ = 2r",
      "D": "r’ = √r"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 456,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0457",
    "numero": 1957,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma dona de casa pretende comprar uma es-\ncrivaninha para colocar entre as duas camas do \nquarto de seus filhos. Ela sabe que o quarto é \nretangular, de dimensões 4 m × 5 m, e que as \ncabeceiras das camas estão encostadas na \nparede de maior dimensão, onde ela pretende \ncolocar a escrivaninha, garantindo uma distân-\ncia de 0,4 m entre a escrivaninha e cada uma \ndas camas, para circulação. Após fazer um es-\nboço com algumas medidas, decidirá se com-\nprará ou não a escrivaninha. \n \n \n \nApós analisar o esboço e realizar alguns cálcu-\nlos, a dona de casa decidiu que poderia com-\nprar uma escrivaninha, de largura máxima igual \na: \n \n \nA) 1,8 m. \nB) 0,8 m. \nC) 1,4 m. \nD) 1,0 m. \nE) 1,6 m.",
    "alternativas": {
      "D": "1,0 m.",
      "E": "1,6 m.",
      "A": "1,8 m.",
      "B": "0,8 m."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 457,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0458",
    "numero": 1958,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O gráfico mostra estimativas da produção brasi-\nleira de trigo em safras recentes: \n \nProdução de trigo no Brasil \n(em milhões de toneladas) \n \n \nA média da produção brasileira de trigo de \n2005/06 a 2009/10, em milhões de toneladas, é \nde: \n \n \nA) 4,49. \nB) 4,70. \nC) 4,87. \nD) 4,56. \nE) 4,09.",
    "alternativas": {
      "C": "4,87.",
      "D": "4,56.",
      "A": "4,49.",
      "B": "4,70."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 458,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0459",
    "numero": 1959,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Luíza decidiu pintar seus cabelos e os de sua \nmãe usando as cores B e C em ambas as tintu-\nras. A cor B é a que tinge os cabelos brancos e \na cor C dá um tom mais claro durante a exposi-\nção à luz. \nLuíza sabe que, em cabelos com muitos fios \nbrancos, como os de sua mãe, a proporção \nentre as cores C e B é de 1 para 3. Para ela, \nque tem poucos fios brancos, a proporção a ser \naplicada é de 3 partes da cor C para 1 parte da \ncor B. Além disso, como sua mãe tem cabelos \ncurtos, basta a aplicação de 60 gramas de tintu-\nra; já para seus longos cabelos, serão necessá-\nrios 120 gramas. De acordo com a situação \ndescrita, a quantidade, em gramas, da tintura da \ncor B que Luíza deve adquirir para pintar os \nseus cabelos e os de sua mãe é: \n \nA) 105. \nB) 60. \nC) 90. \nD) 180. \nE) 75.",
    "alternativas": {
      "E": "75.",
      "B": "60.",
      "C": "90.",
      "D": "180."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 459,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0460",
    "numero": 1960,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Estudos revelam que, independentemente de \netnia, idade e condição social, as pessoas têm \npadrões estéticos comuns de beleza facial e \nque as faces consideradas bonitas apresentam-\nse em proporção áurea. A proporção áurea é a \nconstante Φ = 1,618... \n \nUma agência de modelos reconhece a informa-\nção citada e utiliza-a como critério de beleza \nfacial de suas contratadas. Para entrevistar uma \nnova candidata a modelo, a referida agência \npede uma fotografia de rosto no ato da inscrição \ne, com ela, determina as medidas mostradas na \nfigura. \n \n \n \nAnalisando a fotografia de cinco candidatas, I, II, \nIII, IV e V, para a seleção de uma única garota, \nforam constatadas estas medidas: \n \n• Candidata I: M1 = 11cm; M2 = 5,5cm e            \nM3 = 7cm. \n• Candidata II: M1 = 10,5cm; M2 = 4,5cm e         \nM3 = 6,5cm. \n• Candidata III: M1 = 11,5cm; M2 = 3,5cm e       \nM3 = 6,5cm. \n• Candidata IV: M1 = 10cm; M2 = 4cm e            \nM3 = 6,5cm. \n• Candidata V: M1 = 10,5cm; M2 = 4cm e           \nM3 = 6,5cm. \nA candidata selecionada pela agência de mode-\nlos, segundo os critérios da proporção áurea, \nfoi: \n \n \nA) IV. \nB) II. \nC) III. \nD) I. \nE) V.",
    "alternativas": {
      "B": "II.",
      "C": "III.",
      "D": "I.",
      "E": "V."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 460,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0461",
    "numero": 1961,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "A logomarca de uma empresa de computação é \num quadrado, AEFG, com partes pintadas como \nmostra a figura. Sabe-se que todos os ângulos \nagudos presentes na figura medem 45º e que \nAB = BC = CD = DE. A fim de divulgar a marca \nentre os empregados, a gerência decidiu que \nfossem pintadas logomarcas de diversos tama-\nnhos nas portas, paredes e fachada da empre-\nsa. Pintadas as partes cinza de todas as logo-\nmarcas, sem desperdício e sem sobras, já fo-\nram gastos R$ 320,00. \n \n \n \nO preço das tintas cinza, preta e branca é o \nmesmo. Considerando que não haja desperdício \ne sobras, o custo para pintar as partes pretas e \no custo para pintar as partes brancas serão, \nrespectivamente, \n \n \nA) R$ 2240,00 e R$ 2560,00. \nB) R$ 640,00 e R$ 960,00. \nC) R$ 1280,00 e R$ 2240,00. \nD) R$ 960,00 e R$ 1280,00. \nE) R$ 320,00 e R$ 640,00.",
    "alternativas": {
      "D": "R$ 960,00 e R$ 1280,00.",
      "E": "R$ 320,00 e R$ 640,00.",
      "A": "R$ 2240,00 e R$ 2560,00.",
      "C": "R$ 1280,00 e R$ 2240,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 461,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0462",
    "numero": 1962,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Vulcão Puyehue transforma a paisagem \nde cidades na Argentina \n \nUm vulcão de 2440 m de altura, no Chile, esta-\nva “parado” desde o terremoto em 1960. Foi o \nresponsável por diferentes contratempos, como \natrasos em viagens aéreas, por causa de sua \nfumaça. A cidade de Bariloche foi uma das mais \natingidas pelas cinzas. \nNa aula de Geografia de determinada escola, \nforam confeccionadas pelos estudantes maque-\ntes de vulcões, a uma escala 1 : 40 000. Dentre \nas representações ali produzidas, está a do \nPuyehue, que, mesmo sendo um vulcão imen-\nso, não se compara em estatura com o vulcão \nMauna Loa, que fica no Havaí, considerado o \nmaior vulcão do mundo, com 12000 m de altura. \n \nComparando as maquetes desses dois vulcões, \nqual a diferença, em centímetros, entre elas? \n \n \nA) 20,3 \nB) 1,26 \nC) 23,9 \nD) 3,92 \nE) 4,92",
    "alternativas": {
      "E": "4,92",
      "A": "20,3",
      "B": "1,26",
      "C": "23,9"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 462,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0464",
    "numero": 1964,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O dono de uma empresa produtora de água \nmineral explora uma fonte de onde extrai 20000 \nlitros diários, os quais são armazenados em um \nreservatório com volume interno de 30 m3, para \nserem colocados, ao final do dia, em garrafas \nplásticas.  \n \nPara aumentar a produção, o empresário decide \nexplorar também uma fonte vizinha, de onde \npassa a extrair outros 25000 litros.  \n \nO reservatório que se encontra em uso possui \numa capacidade ociosa que deve ser aproveita-\nda. \n \nAvaliando a capacidade do reservatório existen-\nte e o novo volume de água extraído, qual o \nvolume interno mínimo de um novo reservatório \nque o empresário deve adquirir? \n \n \n \nA) 15,0 m3 \nB) 45,0 m3 \nC) 37,5 m3 \nD) 25,0 m3 \nE) 57,5 m3",
    "alternativas": {
      "D": "25,0 m3",
      "A": "15,0 m3",
      "B": "45,0 m3",
      "C": "37,5 m3"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 464,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0465",
    "numero": 1965,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma pequena fábrica vende seus bonés em \npacotes com quantidades de unidades variá-\nveis. O lucro obtido é dado pela expressão    \nL(x) = −x2 + 12x − 20, onde x representa a quan-\ntidade de bonés contidos no pacote. A empresa \npretende fazer um único tipo de empacotamen-\nto, obtendo um lucro máximo. \n \nPara obter o lucro máximo nas vendas, os paco-\ntes devem conter uma quantidade de bonés \nigual a: \n \n \nA) 9. \nB) 6. \nC) 14. \nD) 4. \nE) 10.",
    "alternativas": {
      "B": "6.",
      "C": "14.",
      "D": "4.",
      "E": "10."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 465,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0466",
    "numero": 1966,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "A cotação de uma moeda em relação a uma \nsegunda moeda é o valor que custa para com-\nprar uma unidade da primeira moeda, utilizando \na segunda moeda. Por exemplo, se a cotação \ndo dólar é 1,6 real, isso significa que para com-\nprar 1 dólar é necessário 1,6 real. \n \nSuponha que a cotação do dólar, em reais, seja \nde 1,6 real, a do euro, em reais, seja de 2,4 \nreais e a cotação da libra, em euros, seja de 1,1 \neuro. \n \nQual é a cotação da libra, em dólares? \n \nA) 1,50 dólar \nB) 1,65 dólar \nC) 1,36 dólar \nD) 2,64 dólares \nE) 4,224 dólares",
    "alternativas": {
      "A": "1,50 dólar",
      "B": "1,65 dólar",
      "D": "2,64 dólares",
      "E": "4,224 dólares"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 466,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0467",
    "numero": 1967,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Certa empresa de telefonia oferece a seus clien-\ntes dois pacotes de serviço: \n \n• Pacote laranja \nOferece 300 minutos mensais de ligação local e \no usuário deve pagar R$ 143,00 por mês. Será \ncobrado o valor de R$ 0,40 por minuto que ex-\nceder o valor oferecido. \n \n• Pacote azul \nOferece 100 minutos mensais de ligação local e \no usuário deve pagar mensalmente R$ 80,00. \nSerá cobrado o valor de R$ 0,90 por minuto que \nexceder o valor oferecido. \n \nPara ser mais vantajoso contratar o pacote la-\nranja, comparativamente ao pacote azul, o nú-\nmero mínimo de minutos de ligação que o usuá-\nrio deverá fazer é: \nA) 400. \nB) 171. \nC) 126. \nD) 300. \nE) 70.",
    "alternativas": {
      "B": "171.",
      "D": "300.",
      "E": "70.",
      "A": "400."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 467,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0468",
    "numero": 1968,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Camile gosta de caminhar em uma calçada em \ntorno de uma praça circular que possui 500 \nmetros de extensão, localizada perto de casa. A \npraça, bem como alguns locais ao seu redor e o \nponto de onde inicia a caminhada, estão repre-\nsentados na figura: \n \n \n \nEm uma tarde, Camile caminhou 4125 metros, \nno sentido anti-horário, e parou. Qual dos locais \nindicados na figura é o mais próximo de sua \nparada? \n \nA) Drogaria. \nB) Padaria. \nC) Ponto de partida. \nD) Lan house. \nE) Centro cultural.",
    "alternativas": {
      "C": "Ponto de partida.",
      "E": "Centro cultural.",
      "A": "Drogaria.",
      "B": "Padaria."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 468,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0469",
    "numero": 1969,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Todos os anos, a Receita Federal alerta os con-\ntribuintes para não deixarem o envio de seus \ndados para o último dia do prazo de entrega, \npois, após esse prazo, terá que pagar uma mul-\nta. Em certo ano, a quatro dias do prazo final, \ncontabilizou-se o recebimento de 16,2 milhões \nde declarações, o equivalente a cerca de 60% \ndo total estimado pela Receita Federal. Nesse \nmesmo momento, foi observado que a média de \nentrada era de aproximadamente 90 000 decla-\nrações por hora. \n \nConsiderando o total estimado para entrega e \npermanecendo nesses últimos dias a mesma \nmédia por hora de recebimentos das declara-\nções, qual a quantidade aproximada de pessoas \nque terão que pagar multa por atraso, sabendo \nque a Receita Federal recebe declarações 24 \nhoras por dia? \nA) 4,05 milhões \nB) 7,65 milhões \nC) 8,64 milhões \nD) 6,21 milhões \nE) 2,16 milhões",
    "alternativas": {
      "C": "8,64 milhões",
      "D": "6,21 milhões",
      "E": "2,16 milhões",
      "B": "7,65 milhões"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 469,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0470",
    "numero": 1970,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "O turismo brasileiro atravessa um período de \nfranca expansão. Entre 2002 e 2006, o número \nde pessoas que trabalham nesse setor aumen-\ntou 15% e chegou a 1,8 milhão. Cerca de 60% \ndesse contingente de trabalhadores está no \nmercado informal, sem carteira assinada. \n \nPara regularizar os empregados informais que \nestão nas atividades ligadas ao turismo, o nú-\nmero de trabalhadores que terá que assinar \ncarteira profissional é: \n \n \nA) 720 mil. \nB) 270 mil. \n \nC) 1,08 milhão. \nD) 810 mil. \nE) 1,35 milhão.",
    "alternativas": {
      "B": "270 mil.",
      "C": "1,08 milhão.",
      "D": "810 mil.",
      "E": "1,35 milhão."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 470,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0471",
    "numero": 1971,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "No filme O colecionador de ossos, produzido \npela Columbia Pictures Corporation — Universal \nPictures, a pista deixada por um suspeito de \ncerto delito foi a marca de uma pegada no chão. \nUma personagem do filme, ciente de que a \nmarca serviria de prova para a investigação, \nfotografou essa marca ao lado de uma nota de \ndólar, que mede aproximadamente 15 cm. \n \nAo revelar a foto, essa personagem obteve uma \nimagem em que o comprimento da cédula de \ndólar media 3 cm e o da marca da pegada me-\ndia 6 cm. Qual a relação numérica entre a mar-\nca no chão e a marca na imagem revelada? \n \nA) 12 vezes maior. \nB) 5 centímetros maior. \nC) 12 centímetros maior. \nD) 5 vezes maior. \nE) 9 centímetros maior.",
    "alternativas": {
      "A": "12 vezes maior.",
      "C": "12 centímetros maior.",
      "D": "5 vezes maior.",
      "E": "9 centímetros maior."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 471,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0472",
    "numero": 1972,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Uma fábrica utiliza sua frota particular de cami-\nnhões para distribuir as 90 toneladas de sua \nprodução semanal. Todos os caminhões são do \nmesmo modelo e, para aumentar a vida útil da \nfrota, adota-se a política de reduzir a capacida-\nde máxima de carga de cada caminhão em \nmeia tonelada. Com essa medida de redução, o \nnúmero de caminhões necessários para trans-\nportar a produção semanal aumenta em 6 uni-\ndades em relação ao número de caminhões \nnecessários para transportar a produção, usan-\ndo a capacidade máxima de carga de cada ca-\nminhão. \n \nQual é o número atual de caminhões que essa \nfábrica usa para transportar a produção sema-\nnal, respeitando-se a política de redução de \ncarga? \n \n \nA) 16 \nB) 36 \nC) 10 \nD) 30 \nE) 19",
    "alternativas": {
      "D": "30",
      "E": "19",
      "A": "16",
      "B": "36"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2013.2",
    "numeroOriginal": 472,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];